<template>
  <div>
      <div class="choice" :style="{height:fullpage + 'px'}">     
          <div class="choice-a">
              <router-link v-for="(video,index) in video_class" :key="index" :to="{ name:'content-category', params: { cate: video.video_id }}"  class="c-prod" :class="['c-prod0'+parseInt(index+1),{'car-icon':cate==2}]">
              <span>{{video.video_cate}}</span></router-link>
          </div>
      </div>
  </div>
</template>
<script>
    export default{
        props: {
            cate: {
                type: String,
                required: true,
            },
        },
        data(){
            return{
              fullpage:document.documentElement.clientHeight,
              video_class:[],
            }
        },
        mounted(){
            this.getVideoClass()
        },
        methods:{
            getVideoClass(){

                this.$axios.get('netusers/videocate',{params:{type:this.cate}})
                .then(
                    res=>{
                        this.video_class=res.data.data.data
                    }
                )
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/mobile/tation/ProductSelect.vue